import { render, staticRenderFns } from "./MenuProductTable.vue?vue&type=template&id=18446db9"
import script from "./MenuProductTable.vue?vue&type=script&lang=js"
export * from "./MenuProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports